module.exports = __webpack_public_path__ + "assets/img/22_1232.f66a43ac.jpg";